module.exports = __webpack_public_path__ + "static/community-grants-sunset-890d173ecf83a260cf8a801eb7c1a2e8.jpg";